/**
 * MyProjectHealthCard — health distribution across the projects I'm a member of.
 * Reuses the rewritten, theme-aware `ProjectHealthDonut` chart (no hard-coded
 * hex) and feeds it only my own projects via `getMyListView()`.
 */

import { useQuery } from '@tanstack/react-query';
import { Card, Center, Group, Skeleton, ThemeIcon, Title } from '@/components/ui';
import { IconHeartRateMonitor } from '@tabler/icons-react';
import { useProjectService, type ProjectModelView } from '@actschurch/ccms-sdk';
import { ProjectHealthDonut } from '../../components/charts';
import { MEMBER_DASHBOARD_KEY } from './dashboardConstants';

export function MyProjectHealthCard() {
  const projectService = useProjectService();

  const { data: myProjects = [], isLoading } = useQuery({
    queryKey: [...MEMBER_DASHBOARD_KEY, 'my-projects'],
    queryFn: () => projectService.getMyListView(),
  });

  return (
    <Card withBorder padding="lg" radius="md">
      <Group gap="xs" mb="md">
        <ThemeIcon size="md" variant="light" color="grape" radius="xl">
          <IconHeartRateMonitor size={16} />
        </ThemeIcon>
        <Title order={5}>My Project Health</Title>
      </Group>

      {isLoading ? (
        <Skeleton height={200} radius="md" />
      ) : (
        <Center>
          <ProjectHealthDonut projects={myProjects as ProjectModelView[]} size={180} />
        </Center>
      )}
    </Card>
  );
}
